import { toastAlert } from '@helpers/Alerts'

export function getItem(key: string, store: Storage): string | null {
	try {
		return store.getItem(key)
	} catch {
		/** We end up here if the Storage instance is disabled */
		warn()
		return undefined
	}
}

export function removeItem(key: string, store: Storage) {
	try {
		store.removeItem(key)
	} catch {
		/** We end up here if the Storage instance is disabled */
		warn()
	}
}

export function setItem(key: string, value: unknown, store: Storage) {
	try {
		if (typeof value === 'string') {
			store.setItem(key, value)
		} else {
			store.setItem(key, JSON.stringify(value))
		}
	} catch {
		/** We end up here if the Storage instance is disabled */
		warn()
	}
}

function warn() {
	const text = 'Session Storage and Local Storage must both be enabled.'
	toastAlert({ text, icon: 'warning' })
}
